import Link from '@components/ui-old/link';
import SearchIcon from '@components/icons/search-icon';
import UserIcon from '@components/icons/user-icon';
import MenuIcon from '@components/icons/menu-icon';
import HomeIcon from '@components/icons/home-icon';
import { useUI } from '@contexts/ui.context';
import { useState } from 'react';
import { useRouter } from 'next/router';
import { ROUTES } from '@utils/routes';
import dynamic from 'next/dynamic';
import { Drawer } from '@components/common/drawer/drawer';
import { getDirection } from '@utils/get-direction';
import motionProps from '@components/common/drawer/motion';
import MobileDashboardNav from '@components/my-account/mobile-dashboard-nav';
const CartButton = dynamic(() => import('@components/cart/cart-button'), {
  ssr: false
});
const AuthMenu = dynamic(() => import('@components/layout/header/auth-menu'), {
  ssr: false
});
const MobileMenu = dynamic(() => import('@components/layout/header/mobile-menu'));
const BottomNavigation: React.FC = () => {
  const {
    openSidebar,
    closeSidebar,
    displaySidebar,
    openSearch,
    openModal,
    setModalView,
    isAuthorized
  } = useUI();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  function toggleMenu() {
    setIsMenuOpen(!isMenuOpen);
  }
  function handleLogin() {
    if (isAuthorized) {
      toggleMenu();
    } else {
      setModalView('LOGIN_VIEW');
      openModal();
    }
  }
  function handleMobileMenu() {
    return openSidebar();
  }
  const {
    locale
  } = useRouter();
  const dir = getDirection(locale);
  const contentWrapperCSS = dir === 'ltr' ? {
    left: 0
  } : {
    right: 0
  };
  return <>
			<div className="lg:hidden fixed z-10 bottom-0 flex items-center justify-between shadow-bottomNavigation text-neutral-700 dark:text-neutral-400 body-font bg-white dark:bg-zinc-950 w-full h-14 sm:h-16 px-4 md:px-8 pb-[env(safe-area-inset-bottom)]">
				<button aria-label="Menu" className="menuBtn flex flex-col items-center justify-center flex-shrink-0 outline-none focus:outline-none" onClick={handleMobileMenu}>
					<MenuIcon data-sentry-element="MenuIcon" data-sentry-source-file="mobile-navigation.tsx" />
				</button>
				<button className="flex items-center justify-center flex-shrink-0 h-auto relative focus:outline-none" onClick={openSearch} aria-label="search-button">
					<SearchIcon data-sentry-element="SearchIcon" data-sentry-source-file="mobile-navigation.tsx" />
				</button>
				<Link href="/" className="flex-shrink-0" data-sentry-element="Link" data-sentry-source-file="mobile-navigation.tsx">
					<HomeIcon data-sentry-element="HomeIcon" data-sentry-source-file="mobile-navigation.tsx" />
				</Link>
				<CartButton data-sentry-element="CartButton" data-sentry-source-file="mobile-navigation.tsx" />
				<AuthMenu isAuthorized={isAuthorized} href={ROUTES.ACCOUNT} className="flex-shrink-0" loading={false} btnProps={{
        className: 'flex-shrink-0 focus:outline-none',
        children: <UserIcon />,
        onClick: handleLogin
      }} data-sentry-element="AuthMenu" data-sentry-source-file="mobile-navigation.tsx" />
			</div>
			{isMenuOpen && <MobileDashboardNav isOpen={isMenuOpen} toggleMenu={toggleMenu} />}
			<Drawer placement={dir === 'rtl' ? 'right' : 'left'} open={displaySidebar} onClose={closeSidebar} contentWrapperStyle={contentWrapperCSS} {...motionProps} data-sentry-element="Drawer" data-sentry-source-file="mobile-navigation.tsx">
				<MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="mobile-navigation.tsx" />
			</Drawer>
		</>;
};
export default BottomNavigation;